/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetUserEngagementChartParams,
  SearchAdminsParams,
  SearchUsersParams,
  SuccessResponseDTOAdminUserDetailsResponseDTO,
  SuccessResponseDTOListEngagementResponseChartDTO,
  SuccessResponseDTOPageResponseUserMgmtResponseDTO,
  SuccessResponseDTOUserMgmtResponseDTO,
  SuccessResponseDTOVoid,
  UserStatusRequestDTO,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Change user status
 */
export const changeUserStatus = (userStatusRequestDTO: UserStatusRequestDTO) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/user-manager/change-status`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: userStatusRequestDTO,
  });
};

export const getChangeUserStatusMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserStatus>>,
    TError,
    { data: UserStatusRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeUserStatus>>,
  TError,
  { data: UserStatusRequestDTO },
  TContext
> => {
  const mutationKey = ['changeUserStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeUserStatus>>,
    { data: UserStatusRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return changeUserStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeUserStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeUserStatus>>
>;
export type ChangeUserStatusMutationBody = UserStatusRequestDTO;
export type ChangeUserStatusMutationError = unknown;

/**
 * @summary Change user status
 */
export const useChangeUserStatus = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeUserStatus>>,
      TError,
      { data: UserStatusRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeUserStatus>>,
  TError,
  { data: UserStatusRequestDTO },
  TContext
> => {
  const mutationOptions = getChangeUserStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get user engagement chart data
 */
export const getUserEngagementChart = (
  userId: number,
  params: GetUserEngagementChartParams,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOListEngagementResponseChartDTO>({
    url: `/admin/api/user-manager/${userId}/engagement/chart`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetUserEngagementChartQueryKey = (
  userId?: number,
  params?: GetUserEngagementChartParams,
) => {
  return [
    `/admin/api/user-manager/${userId}/engagement/chart`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserEngagementChartQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserEngagementChart>>,
  TError = unknown,
>(
  userId: number,
  params: GetUserEngagementChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserEngagementChart>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserEngagementChartQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEngagementChart>>> = ({ signal }) =>
    getUserEngagementChart(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserEngagementChart>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserEngagementChartQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserEngagementChart>>
>;
export type GetUserEngagementChartQueryError = unknown;

export function useGetUserEngagementChart<
  TData = Awaited<ReturnType<typeof getUserEngagementChart>>,
  TError = unknown,
>(
  userId: number,
  params: GetUserEngagementChartParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserEngagementChart>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEngagementChart>>,
          TError,
          Awaited<ReturnType<typeof getUserEngagementChart>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserEngagementChart<
  TData = Awaited<ReturnType<typeof getUserEngagementChart>>,
  TError = unknown,
>(
  userId: number,
  params: GetUserEngagementChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserEngagementChart>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEngagementChart>>,
          TError,
          Awaited<ReturnType<typeof getUserEngagementChart>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserEngagementChart<
  TData = Awaited<ReturnType<typeof getUserEngagementChart>>,
  TError = unknown,
>(
  userId: number,
  params: GetUserEngagementChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserEngagementChart>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user engagement chart data
 */

export function useGetUserEngagementChart<
  TData = Awaited<ReturnType<typeof getUserEngagementChart>>,
  TError = unknown,
>(
  userId: number,
  params: GetUserEngagementChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserEngagementChart>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserEngagementChartQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search users (CREATOR type)
 */
export const searchUsers = (params: SearchUsersParams, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOPageResponseUserMgmtResponseDTO>({
    url: `/admin/api/user-manager/user/search`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getSearchUsersQueryKey = (params?: SearchUsersParams) => {
  return [`/admin/api/user-manager/user/search`, ...(params ? [params] : [])] as const;
};

export const getSearchUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof searchUsers>>,
  TError = unknown,
>(
  params: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsers>>> = ({ signal }) =>
    searchUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>;
export type SearchUsersQueryError = unknown;

export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(
  params: SearchUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsers>>,
          TError,
          Awaited<ReturnType<typeof searchUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(
  params: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsers>>,
          TError,
          Awaited<ReturnType<typeof searchUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(
  params: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search users (CREATOR type)
 */

export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(
  params: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user details
 */
export const getUserDetail = (id: number, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOAdminUserDetailsResponseDTO>({
    url: `/admin/api/user-manager/user/detail/${id}`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetUserDetailQueryKey = (id?: number) => {
  return [`/admin/api/user-manager/user/detail/${id}`] as const;
};

export const getGetUserDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetail>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDetail>>> = ({ signal }) =>
    getUserDetail(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDetail>>>;
export type GetUserDetailQueryError = unknown;

export function useGetUserDetail<
  TData = Awaited<ReturnType<typeof getUserDetail>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserDetail>>,
          TError,
          Awaited<ReturnType<typeof getUserDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserDetail<
  TData = Awaited<ReturnType<typeof getUserDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserDetail>>,
          TError,
          Awaited<ReturnType<typeof getUserDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserDetail<
  TData = Awaited<ReturnType<typeof getUserDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetail>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user details
 */

export function useGetUserDetail<
  TData = Awaited<ReturnType<typeof getUserDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetail>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserDetailQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search admin users (ADMIN type)
 */
export const searchAdmins = (params: SearchAdminsParams, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOPageResponseUserMgmtResponseDTO>({
    url: `/admin/api/user-manager/admin/search`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getSearchAdminsQueryKey = (params?: SearchAdminsParams) => {
  return [`/admin/api/user-manager/admin/search`, ...(params ? [params] : [])] as const;
};

export const getSearchAdminsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchAdmins>>,
  TError = unknown,
>(
  params: SearchAdminsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdmins>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchAdminsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAdmins>>> = ({ signal }) =>
    searchAdmins(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchAdmins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchAdminsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAdmins>>>;
export type SearchAdminsQueryError = unknown;

export function useSearchAdmins<TData = Awaited<ReturnType<typeof searchAdmins>>, TError = unknown>(
  params: SearchAdminsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdmins>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAdmins>>,
          TError,
          Awaited<ReturnType<typeof searchAdmins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchAdmins<TData = Awaited<ReturnType<typeof searchAdmins>>, TError = unknown>(
  params: SearchAdminsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdmins>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAdmins>>,
          TError,
          Awaited<ReturnType<typeof searchAdmins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchAdmins<TData = Awaited<ReturnType<typeof searchAdmins>>, TError = unknown>(
  params: SearchAdminsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdmins>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search admin users (ADMIN type)
 */

export function useSearchAdmins<TData = Awaited<ReturnType<typeof searchAdmins>>, TError = unknown>(
  params: SearchAdminsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdmins>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchAdminsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get admin details
 */
export const getAdminDetail = (id: number, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOUserMgmtResponseDTO>({
    url: `/admin/api/user-manager/admin/detail/${id}`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetAdminDetailQueryKey = (id?: number) => {
  return [`/admin/api/user-manager/admin/detail/${id}`] as const;
};

export const getGetAdminDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDetail>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDetail>>> = ({ signal }) =>
    getAdminDetail(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAdminDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDetail>>>;
export type GetAdminDetailQueryError = unknown;

export function useGetAdminDetail<
  TData = Awaited<ReturnType<typeof getAdminDetail>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDetail>>,
          TError,
          Awaited<ReturnType<typeof getAdminDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminDetail<
  TData = Awaited<ReturnType<typeof getAdminDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDetail>>,
          TError,
          Awaited<ReturnType<typeof getAdminDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminDetail<
  TData = Awaited<ReturnType<typeof getAdminDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDetail>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get admin details
 */

export function useGetAdminDetail<
  TData = Awaited<ReturnType<typeof getAdminDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDetail>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAdminDetailQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
